<template>
  <div class="space-y-3 rounded-2xl bg-default p-4 shadow-sm ring-1 ring-default">
    <USkeleton class="aspect-[4/5] w-full rounded-2xl" />
    <USkeleton class="h-4 w-full" />
    <USkeleton class="h-4 w-3/4" />
    <USkeleton class="h-3 w-1/2" />
    <USkeleton class="h-8 w-28" />
    <USkeleton class="h-10 w-full rounded-lg" />
  </div>
</template>
